/**
 * KAN-851: данные карточки организации в приложении менеджера (/m/companies/:id):
 * та же карточка, что у кабинета (GET client-companies/<id>/), разложенная для
 * показа: место, телефоны, почты, сайт, дополнительные поля (только значения,
 * без пометки "боту") и контакты организации.
 */
import { useMemo } from 'react';
import { useClientCompany } from '@/hooks/useClientCompanies';
import { toExtraFieldItems } from '@/lib/extraFields';
import { companyLocation, nonEmpty, websiteHref } from '@/lib/mobileCompany';
import type { ClientCompanyContact } from '@/types/clientCompany';

export interface MobileCompanyExtraItem {
  name: string;
  value: string;
}

export interface MobileCompanyView {
  name: string;
  inn: string;
  ogrn: string;
  location: string;
  address: string;
  phones: string[];
  emails: string[];
  website: string;
  websiteHref: string;
  extra: MobileCompanyExtraItem[];
  contacts: ClientCompanyContact[];
}

export function useMobileCompany(id: string | undefined) {
  const query = useClientCompany(id);
  const company = query.data;
  const view = useMemo<MobileCompanyView | null>(() => {
    if (!company) return null;
    return {
      name: company.name || 'Организация',
      inn: (company.inn ?? '').trim(),
      ogrn: (company.ogrn ?? '').trim(),
      location: companyLocation(company),
      address: (company.address ?? '').trim(),
      phones: nonEmpty(company.phones),
      emails: nonEmpty(company.emails),
      website: (company.website ?? '').trim(),
      websiteHref: websiteHref(company.website),
      extra: toExtraFieldItems(company.extra).map(({ name, value }) => ({ name, value })),
      contacts: company.contacts ?? [],
    };
  }, [company]);
  return { ...query, view };
}
